import { render, staticRenderFns } from "./SlotSettings.vue?vue&type=template&id=4ab7d832&scoped=true&"
import script from "./SlotSettings.vue?vue&type=script&lang=js&"
export * from "./SlotSettings.vue?vue&type=script&lang=js&"
import style0 from "./SlotSettings.vue?vue&type=style&index=0&id=4ab7d832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7d832",
  null
  
)

export default component.exports